<template>
    <div v-if="reactions && reactions.length" class="absolute -bottom-4 rounded-full px-1.5 py-0.5 shadow-sm border flex items-center space-x-1 z-10 cursor-pointer hover:scale-105 active:scale-95 transition-all" :class="isOutgoing ? 'right-4 bg-[#1F2430] border-gray-700' : 'left-4 bg-white border-gray-100'" @click.stop="$emit('show-details')">
        <span v-for="emoji in uniqueEmojis" :key="emoji" class="text-[10px]" :title="getNamesForEmoji(emoji)">{{ emoji }}</span>
        <span class="text-[8px] font-bold ml-0.5" :class="isOutgoing ? 'text-white/50' : 'text-gray-400'">{{ reactions.length }}</span>
    </div>
</template>

<script>
export default {
    name: 'ChatReaction',
    props: {
        reactions: { type: Array, required: true },
        isOutgoing: { type: Boolean, required: true }
    },
    emits: ['show-details'],
    computed: {
        uniqueEmojis() {
            if (!this.reactions) return [];
            return [...new Set(this.reactions.map(r => r.emoji))];
        }
    },
    methods: {
        getNamesForEmoji(emoji) {
            return (this.reactions || [])
                .filter(r => r.emoji === emoji)
                .map(r => r.user_name || 'Someone')
                .join(', ');
        }
    }
};
</script>
